<template>
  <div class="w100 pl20 pr20 pt20 pb20 bigbox">
    <div class="title">
      工资查询
    </div>
    <div class="tab">
      <el-tabs v-model="userType" type="card" @tab-click="handleClick">
        <el-tab-pane label="在编人员" name="0"></el-tab-pane>
        <el-tab-pane label="聘用人员" name="1"></el-tab-pane>
        <el-tab-pane label="离休人员" name="2"></el-tab-pane>
        <el-tab-pane label="退休人员" name="3"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="table-con" v-loading="loading">
      <Staffing v-if="userType == '0'" :tableData="tableData"/>
      <Hires v-if="userType == '1'" :tableData="tableData"/>
      <Retire v-if="userType == '2'" :tableData="tableData"/>
      <Retirement v-if="userType == '3'" :tableData="tableData"/>
      </div>
      <div class="mt20 flex-box">
        <div class="flex-1"></div>
        <el-pagination
          background
          @size-change="changeSize"
          @current-change="changePage"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    

  </div>
</template>

<script>
import { getMangeList } from '@/api/management/staff';
import Staffing from "./staffing.vue"; //在编人员
import Hires from "./hires.vue"; //聘用人员
import Retire from "./retire"; //离休人员
import Retirement from "./retirement";
export default {
  name: "wageSearch",
  components: {
    Staffing,
    Hires,
    Retire,
    Retirement,
  },
  data() {
    return {
      loading:false,
      tableData:[],
      userType: "0",
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  mounted(){
    this.getTableData()
  },
  methods: {
    async getTableData() {
      this.loading = true;
      let params = {
        current: this.pageNum,
        size: this.pageSize,
        userType:Number(this.userType)
      };
      const { data } = await getMangeList(params);
      this.loading = false
      if (data.code == 0) {
        this.tableData = data.data.records;
        this.total = data.data.total;
      } else {
        this.$message.error(data.msg);
      }
    },
    handleClick() {
      this.pageNum = 1
      this.pageSize = 10
      this.getTableData()
    },
    // 条数
    changeSize(value) {
      this.pageSize = value;
      this.getTableData();
    },
    // 上下页
    changePage(value) {
      this.pageNum = value;
      this.getTableData();
    },
  },
};
</script>

<style lang="less" scoped>

.bigbox{
  height: 100%;
  display: flex;
  flex-direction: column;
.table-con{
  background-color: white;
  margin-top: 10px;
  width: 100%;
  flex: 1;
}

.title{
  padding: 0px 0px 10px 0px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
}
</style>